import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css'// A modern alternative to CSS resets
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css


import store from './store'
import directive from './directive' // directive
import plugins from './plugins' // plugins
import { download } from '@/utils/request'
import { getDicts } from "@/api/dict/data";
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/md";
import './rem';
// 字典数据组件
import DictData from '@/components/DictData'
//import './assets/icons' // icon
import '@/icons' // icon
import './permission' // permission control
import App from './App'
import router from './router'

import VuePrintNb from 'vue-print-nb';



// 字典标签组件
import DictTag from '@/components/DictTag'

// 自定义表格工具组件
// import RightToolbar from "@/components/RightToolbar"

// 富文本组件
import Editor from "@/components/Editor"
//二维码组件
import QRCode from 'qrcodejs2'
component:{QRCode}



import axios from 'axios';
import qs from 'qs';
import vcolorpicker from 'vcolorpicker'
/*import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer)*/
Vue.use(vcolorpicker)
Vue.prototype.qs = qs;
Vue.prototype.axios = axios;
Vue.use(VuePrintNb);
Vue.use(directive)
Vue.use(plugins)
Vue.use(ElementUI, { locale })
Vue.use(VCharts)
DictData.install()

// 全局弹窗点击空白处不关闭,false为不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false;
/**
 * 挂载组件
 */
Vue.prototype.getDicts = getDicts
Vue.prototype.handleTree = handleTree
Vue.prototype.parseTime = parseTime
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.config.productionTip = false
Vue.prototype.resetForm = resetForm
Vue.prototype.download = download




// 全局组件挂载
Vue.component('DictTag', DictTag)
Vue.component('Editor', Editor)
// Vue.component('RightToolbar', RightToolbar)
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js